import { Authority } from '@/shared/security/authority';

const Entities = () => import('@/entities/entities.vue');
const ProjectMenu = () => import('@/entities/project/project-menu.vue');
const ProjectMenuView = () => import('@/entities/project/project-menu-main.vue');
const ProjectMenuCreateTerm = () => import('@/entities/project/project-menu-create-term.vue');
const ProjectMenuUploadCsv = () => import('@/entities/project/project-menu-upload-csv.vue');
const ProjectMenuDownloadCsv = () => import('@/entities/project/project-menu-download-csv.vue');

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: 'projects-menu',
      name: 'ProjectMenu',
      component: ProjectMenu,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'projects-menu/:projectId',
      name: 'ProjectMenuMain',
      component: ProjectMenuView,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'projects-menu/:projectId/create-term',
      name: 'ProjectMenuCreateTerm',
      component: ProjectMenuCreateTerm,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'projects-menu/:projectId/upload-csv',
      name: 'ProjectMenuUploadCsv',
      component: ProjectMenuUploadCsv,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'projects-menu/:projectId/download-csv/:environment',
      name: 'ProjectMenuDownloadCsv',
      component: ProjectMenuDownloadCsv,
      meta: { authorities: [Authority.USER] },
    },
  ],
};
